const CardTotalLicenciados = (props) => {
  return (
    <article className="card">
      <div className="card-header">
        <div className="card-title">
          <span>👥</span>
          <span>{props.title || "Total de licenciados"}</span>
        </div>
      </div>
      <div className="card-body">
        <div className="card-value" id="totalLicenciados">
          {props.total}
        </div>
        <div className="card-sub">
          {props.subtitle || "Contagem geral de usuarios licenciados cadastrados no sistema."}
        </div>
      </div>
    </article>
  );
};

export default CardTotalLicenciados;
